<div class="svg-wrap">
  <div class="tire-name tire-lp-name" [class.active]="currentPosition === TyrePosition.LEFT_FRONT">
    {{ TyrePosition.translateKey(TyrePosition.LEFT_FRONT) | translate | uppercase }}
  </div>
  <div class="tire-name tire-lt-name" [class.active]="currentPosition === TyrePosition.LEFT_REAR">
    {{ TyrePosition.translateKey(TyrePosition.LEFT_REAR) | translate | uppercase }}
  </div>
  <div class="tire-name tire-lt2-name" [class.active]="currentPosition === TyrePosition.LEFT_REAR_2">
    {{ TyrePosition.translateKey(TyrePosition.LEFT_REAR_2) | translate | uppercase }}
  </div>
  <div class="tire-name tire-pp-name" [class.active]="currentPosition === TyrePosition.RIGHT_FRONT">
    {{ TyrePosition.translateKey(TyrePosition.RIGHT_FRONT) | translate | uppercase }}
  </div>
  <div class="tire-name tire-pt-name" [class.active]="currentPosition === TyrePosition.RIGHT_REAR">
    {{ TyrePosition.translateKey(TyrePosition.RIGHT_REAR) | translate | uppercase }}
  </div>
  <div class="tire-name tire-pt2-name" [class.active]="currentPosition === TyrePosition.RIGHT_REAR_2">
    {{ TyrePosition.translateKey(TyrePosition.RIGHT_REAR_2) | translate | uppercase }}
  </div>

  <svg width="122" height="128" viewBox="0 0 122 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35 0H40C42.2091 0 44 1.79086 44 4V9.04779L56 10.1538V8.5C56 6.01472 58.0147 4 60.5 4C62.9853 4 65 6.01472 65 8.5V10.058L76 9.00355V4C76 1.79086 77.7909 0 80 0H85C87.2091 0 89 1.79086 89 4V18C89 20.2091 87.2091 22 85 22H80C77.7909 22 76 20.2091 76 18V13.9522L65 12.9383V14.5C65 16.0681 64.1979 17.4489 62.9817 18.2544L61.9183 33H65C66.1046 33 67 33.8954 67 35V39C67 40.1046 66.1046 41 65 41H61.9676L62.9847 57.7476C64.1993 58.5534 65 59.9332 65 61.5V63.058L76 62.0036V57C76 54.7909 77.7909 53 80 53H85C87.2091 53 89 54.7909 89 57V71C89 73.2091 87.2091 75 85 75H80C77.7909 75 76 73.2091 76 71V66.9522L65 65.9383V67.5C65 69.0681 64.1979 70.4489 62.9817 71.2544L61.9726 85.2465C63.7347 85.8564 65 87.5304 65 89.5V91.058L76 90.0035V85C76 82.7909 77.7909 81 80 81H85C87.2091 81 89 82.7909 89 85V99C89 101.209 87.2091 103 85 103H80C77.7909 103 76 101.209 76 99V94.9522L65 93.9383V95.5C65 97.9853 62.9853 100 60.5 100C58.0147 100 56 97.9853 56 95.5V93.8462L44 94.9965V99C44 101.209 42.2091 103 40 103H35C32.7909 103 31 101.209 31 99V85C31 82.7909 32.7909 81 35 81H40C42.2091 81 44 82.7909 44 85V90.0478L56 91.1538V89.5C56 87.5304 57.2653 85.8564 59.0274 85.2465L58.0183 71.2544C56.8021 70.4489 56 69.0681 56 67.5V65.8462L44 66.9965V71C44 73.2091 42.2091 75 40 75H35C32.7909 75 31 73.2091 31 71V57C31 54.7909 32.7909 53 35 53H40C42.2091 53 44 54.7909 44 57V62.0478L56 63.1538V61.5C56 59.9332 56.8007 58.5534 58.0153 57.7476L59.0324 41H56C54.8954 41 54 40.1046 54 39V35C54 33.8954 54.8954 33 56 33H59.0817L58.0183 18.2544C56.8021 17.4489 56 16.0681 56 14.5V12.8462L44 13.9965V18C44 20.2091 42.2091 22 40 22H35C32.7909 22 31 20.2091 31 18V4C31 1.79086 32.7909 0 35 0ZM35 2C33.8954 2 33 2.89543 33 4V18C33 19.1046 33.8954 20 35 20H40C41.1046 20 42 19.1046 42 18V4C42 2.89543 41.1046 2 40 2H35ZM58 89.5C58 88.1193 59.1193 87 60.5 87C61.8807 87 63 88.1193 63 89.5V95.5C63 96.8807 61.8807 98 60.5 98C59.1193 98 58 96.8807 58 95.5V89.5ZM35 55C33.8954 55 33 55.8954 33 57V71C33 72.1046 33.8954 73 35 73H40C41.1046 73 42 72.1046 42 71V57C42 55.8954 41.1046 55 40 55H35ZM33 85C33 83.8954 33.8954 83 35 83H40C41.1046 83 42 83.8954 42 85V99C42 100.105 41.1046 101 40 101H35C33.8954 101 33 100.105 33 99V85ZM60.5 6C59.1193 6 58 7.11929 58 8.5V14.5C58 15.8807 59.1193 17 60.5 17C61.8807 17 63 15.8807 63 14.5V8.5C63 7.11929 61.8807 6 60.5 6ZM58 61.5C58 60.1193 59.1193 59 60.5 59C61.8807 59 63 60.1193 63 61.5V67.5C63 68.8807 61.8807 70 60.5 70C59.1193 70 58 68.8807 58 67.5V61.5ZM78 4C78 2.89543 78.8954 2 80 2H85C86.1046 2 87 2.89543 87 4V18C87 19.1046 86.1046 20 85 20H80C78.8954 20 78 19.1046 78 18V4ZM80 55C78.8954 55 78 55.8954 78 57V71C78 72.1046 78.8954 73 80 73H85C86.1046 73 87 72.1046 87 71V57C87 55.8954 86.1046 55 85 55H80ZM78 85C78 83.8954 78.8954 83 80 83H85C86.1046 83 87 83.8954 87 85V99C87 100.105 86.1046 101 85 101H80C78.8954 101 78 100.105 78 99V85Z"
      fill="#D9D9D9"
    />
    <rect
      (click)="onSwitchTyreClick(TyrePosition.RIGHT_FRONT)"
      [dataCy]="'tire-interactive-' + TyrePosition.RIGHT_FRONT"
      [class.active]="currentPosition === TyrePosition.RIGHT_FRONT"
      class="tire tire-pp"
      x="77"
      y="1"
      width="12.4444"
      height="22"
      rx="4"
      stroke="#DBDDE0"
      stroke-width="2"
      fill="white"
    />

    <rect
      class="tire tire-lp"
      [dataCy]="'tire-interactive-' + TyrePosition.LEFT_FRONT"
      (click)="onSwitchTyreClick(TyrePosition.LEFT_FRONT)"
      [class.active]="currentPosition === TyrePosition.LEFT_FRONT"
      x="32"
      y="1"
      width="12.4444"
      height="22"
      rx="4"
      stroke="#DBDDE0"
      stroke-width="2"
      fill="white"
    />

    <rect
      class="tire tire-lp"
      [dataCy]="'tire-interactive-' + TyrePosition.RIGHT_REAR"
      (click)="onSwitchTyreClick(TyrePosition.RIGHT_REAR)"
      [class.active]="currentPosition === TyrePosition.RIGHT_REAR"
      x="77"
      y="53"
      width="12.4444"
      height="22"
      rx="4"
      stroke="#DBDDE0"
      stroke-width="2"
      fill="white"
    />

    <rect
      class="tire tire-lp"
      [dataCy]="'tire-interactive-' + TyrePosition.LEFT_REAR"
      (click)="onSwitchTyreClick(TyrePosition.LEFT_REAR)"
      [class.active]="currentPosition === TyrePosition.LEFT_REAR"
      x="32"
      y="53"
      width="12.4444"
      height="22"
      rx="4"
      stroke="#DBDDE0"
      stroke-width="2"
      fill="white"
    />

    <rect
      class="tire tire-pt2"
      [dataCy]="'tire-interactive-' + TyrePosition.RIGHT_REAR_2"
      (click)="onSwitchTyreClick(TyrePosition.RIGHT_REAR_2)"
      [class.active]="currentPosition === TyrePosition.RIGHT_REAR_2"
      x="77"
      y="82"
      width="12.4444"
      height="22"
      rx="4"
      stroke="#DBDDE0"
      stroke-width="2"
      fill="white"
    />

    <rect
      class="tire tire-lt2"
      [dataCy]="'tire-interactive-' + TyrePosition.LEFT_REAR_2"
      (click)="onSwitchTyreClick(TyrePosition.LEFT_REAR_2)"
      [class.active]="currentPosition === TyrePosition.LEFT_REAR_2"
      x="32"
      y="82"
      width="12.4444"
      height="22"
      rx="4"
      stroke="#DBDDE0"
      stroke-width="2"
      fill="white"
    />
  </svg>
</div>
